<template>
  <div>
    <a
      class="arrow-link"
      :href="href"
    >
      <!--
      <svg class="icon-arrow">
        <use xlink:href="#icon-flat-arrow"></use>
      </svg>
      -->
      <div
        class="label"
        :class="{'light' : light}"
      >{{ text }}</div>
    </a>
  </div>
</template>

<script>

export default {
  name: 'ArrowLink',
  props: {
    href: {
      type: String,
      default: '#0',
    },
    text: {
      type: String,
      default: 'En savoir plus',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../sass/config/vars";
@import "../../../sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.arrow-link {
  cursor: pointer;
  display: flex;

  .icon-arrow {
    fill: $primary-yellow;
    height: 0.7rem;
    margin: 0.2rem 1.3rem 0 0;
    width: 3.5rem;
  }

  .label {
    color: #000;
    font-family: $f-graphie-bold;
    font-size: 1.3rem;
    line-height: 1.6rem;
    margin-right: 1.2rem;
    position: relative;

    &:not(.light) {
      &::after {
        background-color: black;
        bottom: -2px;
        content: ' ';
        height: 100%;
        height: 2px;
        left: 0%;
        position: absolute;
        transition: 0.2s width ease-in-out;
        width: 0;
        width: 50%;
      }

      &:hover {
        //color: $sunglow;
        &::after {
          background-color: black;
          bottom: -2px;
          content: ' ';
          height: 100%;
          height: 2px;
          left: 50%;
          position: absolute;
          transition: 0.2s width ease-in-out;
          width: 0;
          width: 50%;
        }
      }
    }
  }

  .light {
    color: $c-nevada;
    font-family: $f-graphie-bold;

    &:hover {
      color: $orange;
    }
  }
}

</style>
